export default __webpack_public_path__ + "static/media/STARDUST_16x9_MASTER_BLACK_260622.8b04b385.mp4";